module.exports = __webpack_public_path__ + "img/DESIGN_02_video_prew.f889d689.jpg";